import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const badPoints = ['Improvisa sin planos claros', 'Cables a la vista y desprolijos', 'Vidrio que se rompe fácilmente', 'Resultados mediocres y opacos', 'Sin conocimiento real de LED'];
  const goodPoints = ['Planos exactos paso a paso', 'Cableado oculto nivel profesional', 'Vidrio templado perfecto y seguro', 'Acabado de lujo de alta gama', 'Dominio total de iluminación LED'];
  return <section className="py-12 px-4 relative z-10 bg-[#09090b]" data-id="element-56">
      <div className="max-w-5xl mx-auto" data-id="element-57">
        <div className="text-center mb-16" data-id="element-58">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-[1.1]" data-id="element-59">
            ¿Qué tipo de creador sos?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-60">
            La diferencia entre un hobby y un negocio rentable.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-61">
          {/* Bad Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#18181b] border border-[#27272a] rounded-2xl p-8 md:p-10" data-id="element-62">
            <div className="mb-8 border-b border-[#27272a] pb-6" data-id="element-63">
              <h3 className="text-2xl font-bold text-gray-300" data-id="element-64">
                Carpintero Común
              </h3>
              <p className="text-gray-500 mt-2 text-sm" data-id="element-65">
                Pierde tiempo y materiales
              </p>
            </div>
            <ul className="space-y-5" data-id="element-66">
              {badPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-gray-400" data-id="element-67">
                  <div className="bg-red-500/10 p-1.5 rounded-lg shrink-0 mt-0.5" data-id="element-68">
                    <XIcon className="w-4 h-4 text-red-400" data-id="element-69" />
                  </div>
                  <span className="leading-relaxed" data-id="element-70">{point}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Good Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#18181b] border border-[#00f0ff]/30 rounded-2xl p-8 md:p-10 relative overflow-hidden shadow-[0_8px_30px_rgba(0,240,255,0.05)]" data-id="element-71">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#00f0ff]/5 blur-[60px] rounded-full pointer-events-none" data-id="element-72" />

            <div className="mb-8 border-b border-[#27272a] pb-6 relative z-10" data-id="element-73">
              <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-[#00f0ff]/10 text-[#00f0ff] text-xs font-bold mb-3" data-id="element-74">
                <CheckIcon className="w-3 h-3" data-id="element-75" /> EL OBJETIVO
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-76">
                Maestro de la Ilusión
              </h3>
              <p className="text-gray-400 mt-2 text-sm" data-id="element-77">
                Crea piezas de alto valor
              </p>
            </div>
            <ul className="space-y-5 relative z-10" data-id="element-78">
              {goodPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-gray-200 font-medium" data-id="element-79">
                  <div className="bg-[#00f0ff]/10 p-1.5 rounded-lg shrink-0 mt-0.5" data-id="element-80">
                    <CheckIcon className="w-4 h-4 text-[#00f0ff]" data-id="element-81" />
                  </div>
                  <span className="leading-relaxed" data-id="element-82">{point}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}